/** Sections protocoles FR/EN — BT-028-R3. */

const PROTOCOLE_SECTIONS_FR = [
  {
    id: "titres",
    titre: "Titres martiaux (aperçu)",
    contenu:
      "Sensei, Renshi, Shihan, Kyoshi, Hanshi — définitions selon le protocole Black Dragon Canadien. Publication complète soumise à validation Hanshi.",
    visibilite: "a_valider",
  },
  {
    id: "ceintures",
    titre: "Grades ceinture (kyu / dan)",
    contenu:
      "Blanche, jaune, orange, verte, bleue, brune, noire — progression par examens supervisés. Détail officiel à importer après validation.",
    visibilite: "membres",
  },
  {
    id: "public",
    titre: "Présentation publique",
    contenu:
      "Le karaté Shotokan AAMC / Black Dragon regroupe plusieurs dojos sous la direction du Hanshi. Phase 1 : portail d'information et d'organisation.",
    visibilite: "public",
  },
];

const PROTOCOLE_SECTIONS_EN = [
  {
    id: "titres",
    titre: "Martial titles (overview)",
    contenu:
      "Sensei, Renshi, Shihan, Kyoshi, Hanshi — definitions per Canadian Black Dragon protocol. Full publication subject to Hanshi validation.",
    visibilite: "a_valider",
  },
  {
    id: "ceintures",
    titre: "Belt grades (kyu / dan)",
    contenu:
      "White, yellow, orange, green, blue, brown, black — progression through supervised exams. Official detail to import after validation.",
    visibilite: "membres",
  },
  {
    id: "public",
    titre: "Public presentation",
    contenu:
      "Shotokan AAMC / Black Dragon karate brings several dojos under Hanshi direction. Phase 1: information and organisation portal.",
    visibilite: "public",
  },
];

/** @param {'fr'|'en'} locale */
export function getProtocoleSections(locale = "fr") {
  return locale === "en" ? PROTOCOLE_SECTIONS_EN : PROTOCOLE_SECTIONS_FR;
}
